<template>
  <div class="feny" v-if="this.$store.state.webNavigator=='pc'">
    <nav class="feny">
      <ul class="pagination">
        <li :class="{'disabled': current == 1}"><a href="javascript:;" @click="setCurrent(current - 1)"> « </a></li>
        <li :class="{'disabled': current == 1}"><a href="javascript:;" @click="setCurrent(1)"> 首页 </a></li>
        <li v-for="(p , index) in grouplist" :class="{'active': current == p.val}" :key="index"><a href="javascript:;" @click="setCurrent(p.val)"> {{ p.text }} </a>
        </li>
        <li :class="{'disabled': current == page}"><a href="javascript:;" @click="setCurrent(page)"> 尾页 </a></li>
        <li :class="{'disabled': current == page}"><a href="javascript:;" @click="setCurrent(current + 1)"> »</a></li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  data () {
    return {
      current: this.currentPage,
    };
  },
  props: {
    total: {// 数据总条数
      type: Number,
      default: 0,
    },
    display: {// 每页显示条数
      type: Number,
      default: 24,
    },
    currentPage: {// 当前页码
      type: Number,
      default: 1,
    },
    pagegroup: {// 分页条数
      type: Number,
      default: 5,
      coerce (v) {
        v = v > 0 ? v : 5;
        return v % 2 === 1 ? v : v + 1;
      },
    },
  },
  computed: {
    page () { // 总页数
      return Math.ceil(this.total / this.display);
    },
    grouplist () { // 获取分页页码
      var len = this.page, temp = [], list = [], count = Math.floor(this.pagegroup / 2), center = this.current;
      if (len <= this.pagegroup) {
        while (len--) {
          temp.push({text: this.page - len, val: this.page - len, });
        }
        ;
        return temp;
      }
      while (len--) {
        temp.push(this.page - len);
      }
      ;
      var idx = temp.indexOf(center);
      (idx < count) && (center = center + count - idx);
      (this.current > this.page - count) && (center = this.page - count);
      temp = temp.splice(center - count - 1, this.pagegroup);
      do {
        var t = temp.shift();
        list.push({
          text: t,
          val: t,
        });
      } while (temp.length);
      if (this.page > this.pagegroup) {
        (this.current > count + 1) && list.unshift({text: '...', val: list[0].val - 1, });
        (this.current < this.page - count) && list.push({text: '...', val: list[list.length - 1].val + 1, });
      }
      return list;
    },
  },
  methods: {
    setCurrent (idx) {
      if (this.current != idx && idx > 0 && idx < this.page + 1) {
        this.current = idx;
        this.$emit('pagechange', this.current);
      }
    },
  },
};
</script>

<style lang="less" scoped>
  @import url('../../../static/css/fontSize.less');
  .pagination {
    overflow: hidden;
    display: table;
    margin: 98*@width/2 auto 74*@width/2 auto;
    /*width: 100%;*/
    height: 50*@width/2;

    li {
      float: left;
      width: 40*@width/2;
      height: 40*@width/2;
      background:rgba(229,229,229,1);
      border-radius: 5*@width/2;
      margin-right: 12*@width/2;

      &:hover {
        background:#00CDA2;
        a {
          color: #fff;
        }
      }

      a {
        white-space: nowrap;
        font-size:14*@width/2;
        font-weight:bold;
        line-height:31*@width/2;
        display: block;
        width: auto;
        height: 30*@width/2;
        padding: 5*@width/2;
        text-align: center;
        border-radius: 5*@width/2;
        text-decoration: none
      }
    }

    .active {
      background:#00CDA2;

      a {
        color: #fff;
      }

    }
  }

</style>



// WEBPACK FOOTER //
// Pagination.vue